import axios from 'axios';
import authService from '@/auth/authService';
import getters from './getters';
import authHeader from '@/services/auth-header';

export default {
  namespaced: true,
  state() {
    return {
      loggedIn: authService.isAuthenticated(),
      all: []
    };
  },
  getters,
  actions: {
    async fetchProfile({ commit }) {
      try {
        const response = await axios.get("/my-account", { headers: authHeader() });
        const data = response.data;

        // Crossover / no-access cases are handled centrally by the axios
        // response interceptor (hard external redirect before this resolves).
        commit('setProfile', data);
        return data;
      } catch (error) {
        console.error('Error fetching profile:', error);
        throw error;
      }
    },
    validateReportPermission({ commit }) {
      axios
        .post('/client-entitled', { headers: authHeader() })
        .then((response) => commit('setAll', response.data));
    },

    async getReportNavigation({ commit }) {
      try {
        const response = await axios.get('/tools-menu', { headers: authHeader() });
        commit('setNavigation', response.data);
      } catch (error) {
        console.error('Error fetching navigation data:', error);
      }
    },
  },
  mutations: {
    setAll(state, data) {
      state.all = data.data;
    },
    setNavigation(state, data) {
      localStorage.setItem('toolData', JSON.stringify(data.data));
    },
    setProfile(state, data) {
      localStorage.setItem('user', JSON.stringify(data));
      if (data?.data?.role === 'Super Admin' || data?.data?.role === ' Data Admin' || data?.data?.role === 'Account Admin' || data?.data?.role === ' Data Admin Supervisor') {
        localStorage.setItem('lang', 'en');
      }
    },
  }
};